import React, { Component } from 'react';
import { Link } from 'react-router-dom';
// import $ from 'jquery';
// import 'magnific-popup';

import aboutimg from '../../../assets/img/text-block/05.jpg';
import videobg from '../../../assets/img/text-block/04.jpg';

import testImg1 from '../../../assets/img/icon/01.png';
import testImg1Bg from '../../../assets/img/icon/01-bg.png';
import testImg2 from '../../../assets/img/icon/02.png';
import testImg2Bg from '../../../assets/img/icon/02-bg.png';
import testImg3 from '../../../assets/img/icon/03.png';
import testImg3Bg from '../../../assets/img/icon/03-bg.png';
import testImg4 from '../../../assets/img/icon/04.png';
import testImg4Bg from '../../../assets/img/icon/04-bg.png';
import testImg5 from '../../../assets/img/icon/05.png';
import testImg5Bg from '../../../assets/img/icon/05-bg.png';

import video from '../../../assets/video/video.mp4';
const featuresposts = [
    { img: testImg1, imgHover: testImg1Bg, title: 'Test image 1' },
    { img: testImg2, imgHover: testImg2Bg, title: 'Test image 2' },
    { img: testImg3, imgHover: testImg3Bg, title: 'Test image 3' },
    { img: testImg4, imgHover: testImg4Bg, title: 'Test image 4' },
    { img: testImg5, imgHover: testImg5Bg, title: 'Test image 5' },
];

class About extends Component {
    /*
        componentDidMount(){
            function popup(){
                $('.popup-video').magnificPopup({
                    type: 'iframe',
                });
            }
            popup();
        }
    */
    render() {
        return (
            <section className="about-section pt-115 pb-115">
                <div className="container">
                    <div className="video-wrap video-wrap-two video-about mb-60" style={{ backgroundImage: "url(" + videobg + ")" }}>
                        <video src={video} muted autoPlay loop playsInline className='about-video'>Your browser does not support this video</video>
                    </div>
                    <div className="section-title about-title text-center">

                        <h2>Somos una empresa mayorista especializada en oro laminado y acero inoxidable</h2>
                    </div>
                    <ul className="about-features">
                        {featuresposts.map((item, i) => (
                            <FeatureIcon key={i} {...item} />
                        ))}
                    </ul>
                    <div className="about-text-box">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="about-img">
                                    <img src={aboutimg} alt="images" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div >
                                    <h2>Con una inversión mínima de solo $1,000 pesos</h2>
                                    <h4 className="mb-4 mt-5">
                                        tendrás acceso a productos de alta calidad y gran demanda.</h4>
                                    <h4 className="mb-4 mt-4"> Realizamos visitas cada 15 días en tu ciudad para brindarte atención personalizada, asesoría y apoyo en tus ventas. </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
        );
    }
}
function FeatureIcon({ img, imgHover, title }) {
    const [hover, setHover] = React.useState(false);
    return (
        <li
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            <Link>
                <img
                    src={hover ? imgHover : img}
                    alt={title}
                    className='feature-icon'
                />
            </Link>
        </li>
    );
}
export default About;
